// Marca RIIA — quatro nós conectados por dois cotovelos, três em marinho e um
// em verde. Geometria medida do arquivo original do cliente; a assinatura do
// desenho são os VÃOS BRANCOS em volta de cada nó, feitos com círculos brancos
// desenhados entre as barras e os nós.
//
// Vetorial de propósito: o mesmo desenho serve a sidebar (32px), o login (40px)
// e o favicon, sem depender de um PNG por tamanho. Conferido renderizando lado a
// lado com o arquivo original.
const MARINHO = '#13305f';
const VERDE   = '#16a34a';

export function MarcaRiia({ size = 32, titulo = 'RIIA', fundo = null }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={titulo}>
      {fundo && <rect width="100" height="100" rx="20" fill={fundo} />}
      <g fill="none" strokeWidth="15" strokeLinecap="round">
        <path d="M48.5 32 H62 Q70.25 32 70.25 40.25 V65" stroke={VERDE} />
        <path d="M30.75 40 V63.75 Q30.75 72 39 72 H54.5" stroke={MARINHO} />
      </g>
      {/* Vãos: abrem o respiro entre as barras e os nós */}
      <g fill={fundo || '#ffffff'}>
        <circle cx="26" cy="26" r="13.1" /><circle cx="74" cy="26" r="13.1" />
        <circle cx="26" cy="74" r="13.1" /><circle cx="74" cy="74" r="13.1" />
      </g>
      <circle cx="26" cy="26" r="10.4" fill={MARINHO} />
      <circle cx="74" cy="26" r="10.4" fill={VERDE} />
      <circle cx="26" cy="74" r="10.4" fill={MARINHO} />
      <circle cx="74" cy="74" r="10.4" fill={MARINHO} />
    </svg>
  );
}

// Assinatura completa: marca + nome + tagline. Usada no login.
export function LogoRiia({ size = 40, comTagline = true }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <MarcaRiia size={size} fundo="#ffffff" />
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontWeight: 800, fontSize: 18, letterSpacing: '0.02em', color: '#fff' }}>RIIA</div>
        {comTagline && (
          <div style={{ fontSize: 11, color: '#9aa0b6', letterSpacing: '0.06em' }}>ATENDIMENTO</div>
        )}
      </div>
    </div>
  );
}

export default MarcaRiia;
